import { useContext } from 'react';

import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

import { ModalContext } from 'src/context/Modal/ModalContext';

import { ComponentProps } from 'src/lib/ComponentProps';

import { Modal } from 'src/components/basicContent/_Modal/Modal';

type ModalsProps = ComponentProps;

export default function Modals(props: ModalsProps): JSX.Element {
	const ModalState = useContext(ModalContext);

	return (
		<>
			{/* Login Modal */}
			<Modal
				modalState={ModalState.modalInfo?.LoginFormModal?.Display ?? false}
				setModalState={ModalState.updateDisplayLoginFormModal}
				afterClose={() => ModalState.updateDisplayLoginFormModal(false)}
			>
				<Placeholder name="rcnlearn-loginmodal" rendering={props.rendering} />
			</Modal>
		</>
	);
}
